import { LoadableAfterPaint } from '@confluence/loadable';

export default LoadableAfterPaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-atlassiansoxengagekitengagement-messages" */ '@atlassiansox/engagekit-ts/engagement-messages'
		),
});
